export function payrollDates(search) {
  const params = new URLSearchParams(search);
  const startDate = params.get('startDate'), endDate = params.get('endDate');
  const valid = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') &&
    !Number.isNaN(Date.parse(value + 'T12:00:00Z')) && new Date(value + 'T12:00:00Z').toISOString().slice(0, 10) === value;
  return valid(startDate) && valid(endDate) && startDate <= endDate ? {startDate, endDate} : null;
}

export function payrollLocation(user, locations, id) {
  if (['admin', 'general_manager'].includes(user?.role)) return locations.find(location => location.id === id) || null;
  return user?.role === 'manager' && user.restaurantId === id
    ? {id, name: user.restaurantName || id} : null;
}
